import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Pathless layout — allows nested routes under /platform/subsidiaries/:subsidiaryId. */
export const Route = createFileRoute('/_authenticated/_tenant/platform/subsidiaries/$subsidiaryId')(
  {
    component: () => <Outlet />,
  },
);
